

module.exports = __webpack_require__.stylable.create(
    "mobile2696523969",
    {"classes":{"root":"mobile2696523969__root","readMore":"mobile2696523969__readMore"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "mobile2696523969",
    null
);
